import logAnalyticsEvent from "./logAnalyticsEvent";

export default function installGlobalErrorHandler() {
  window.onerror = (message, source, lineNumber, columnNumber, error) => {
    if (error) {
      window.onerror = null;
      logAnalyticsEvent("window_onerror", {
        message,
        source,
        lineNumber,
        columnNumber,
        error
      });
    }
  };
}
